import { Action } from '@ngrx/store';
import * as models from '../../domain/models';
import * as viewModels from '../../view/view-models';

export const LOAD = '[RM Vendor Offers Collection] Load';
export const LOAD_SUCCESS = '[RM Vendor Offers Collection] Load Success';
export const LOAD_FAIL = '[RM Vendor Offers Collection] Load Fail';
export const RESET = '[RM Vendor Offers Collection] Reset';

export class LoadActionPayload {
    lookup: viewModels.VendorOffersLookup;
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadActionPayload) {}
}

export class LoadSuccessActionPayload {
    offers: Array<models.OperatorPurchaseOffer>;
    total: number;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessActionPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions =
  | LoadAction
  | LoadSuccessAction
  | LoadFailAction
  | ResetAction;
